import { render, staticRenderFns } from "./_postSlug.vue?vue&type=template&id=5b726888&scoped=true&"
import script from "./_postSlug.vue?vue&type=script&lang=js&"
export * from "./_postSlug.vue?vue&type=script&lang=js&"
import style0 from "./_postSlug.vue?vue&type=style&index=0&id=5b726888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b726888",
  null
  
)

export default component.exports